// @flow

import type {LatLngLiteral} from "../../../Utils/MapUtils";
import {LatLngEnum} from "../../../Utils/AppUtils";
import type {State} from "../../Store";
import ServiceConfigSelectors from "../ServiceConfig/selectors";
import {getPolygonIfLatLngInManualSelectionPolygon} from "../../../Utils/MapUtils";
import MapDataSelectors from "../MapData/selectors";
import type {CurrentRequest} from "./reducers";
import type {TokenData} from "../TokenData/reducers";


export const handleTokenUpdateData = (oldCurrentRequest: CurrentRequest, newCurrentRequest: TokenData): CurrentRequest => {
    newCurrentRequest.origin_type = newCurrentRequest.origin_type || LatLngEnum.CENTER_ONLY;
    newCurrentRequest.dest_type = newCurrentRequest.dest_type || LatLngEnum.CENTER_ONLY;

    return {
        ...oldCurrentRequest,
        passenger_count: newCurrentRequest.passenger_count,

        origin_type: newCurrentRequest.origin_type,
        dest_type: newCurrentRequest.dest_type,

        origin_lat: oldCurrentRequest.origin_lat || newCurrentRequest.origin_lat,
        origin_lng: oldCurrentRequest.origin_lng || newCurrentRequest.origin_lng,
        origin_selection: oldCurrentRequest.origin_selection || StopSelection.NONE,
        dest_lat: oldCurrentRequest.dest_lat || newCurrentRequest.dest_lat,
        dest_lng: oldCurrentRequest.dest_lng || newCurrentRequest.dest_lng,
        dest_selection: oldCurrentRequest.dest_selection || StopSelection.NONE,
        city_id: newCurrentRequest.city_id || oldCurrentRequest.city_id
    };
};

export const getManualSelectionPolygonIfManualSelection = (state: State) => {
    const mapCenter = MapDataSelectors.getMapCenter(state);
    const servicePolygons = ServiceConfigSelectors.getServicePolygons(state);
    return getPolygonIfLatLngInManualSelectionPolygon(mapCenter, servicePolygons);
};

export const StopSelection = {
    "NONE": "NONE",
    "FREE": "FREE",
    "MANUAL": "MANUAL",
};
export type StopSelectionType = $Values<typeof StopSelection>
export type StopRequest = { label: string, latlng?: LatLngLiteral, selection: StopSelectionType };


// WEBPACK FOOTER //
// ./src/Store/Ducks/CurrentRequest/utils.js